import axios from 'axios';
import { API_URL, GYPSYBALL_PYTHON_API_URL, GYPSYBALL_PYTHON_API_TOKEN } from 'configs';

import { isEmpty } from 'lodash';
import { useDispatch } from 'react-redux';

import { v4 as uuidv4 } from 'uuid';
export const SCOPES_REQUEST = 'SCOPES_REQUEST';
export const SCOPES_SUCCESS = 'SCOPES_SUCCESS';
export const SCOPES_VALIDATION_ERROR = 'SCOPES_VALIDATION_ERROR';
const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const HIDE_SCOPES_FEILD_VALIDATION_ERROR = 'HIDE_SCOPES_FEILD_VALIDATION_ERROR';
export const REDIRECT_TO_SCOPES_LIST = 'REDIRECT_TO_SCOPES_LIST';

export const SCOPES_GET_SUCCESS = 'SCOPES_GET_SUCCESS';
export const SCOPES_DROPDOWN_LIST_SUCCESS = 'SCOPES_DROPDOWN_LIST_SUCCESS';
export const SCOPES_SERVER_SUCCESS = 'SCOPES_SERVER_SUCCESS';


const SHOW_LOADER = 'SHOW_LOADER';
const HIDE_LOADER = 'HIDE_LOADER';




const showCommonLoader = (label = '') => ({
  type: SHOW_LOADER,
  common_loder_label: label
});
const hideCommonLoader = () => ({
  type: HIDE_LOADER
});

const scopesRequest = () => ({
  type: SCOPES_REQUEST
});



export const scopesServerListSuccess = () => ({
  type: SCOPES_SERVER_SUCCESS
});

const scopesListSuccess = scopesList => ({
  type: SCOPES_SUCCESS,
  scopesList: scopesList
});


export const scopesFailure = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'general_error'
});

const validationError = notification => ({
  type: SCOPES_VALIDATION_ERROR,
  validation_error: notification
});
const tokenError = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'token_expire'
});





const scopesAddUpadteSuccess = (message, action, dispatch) => {
  dispatch(scopesSuccessNotification(message));
  dispatch(redirectToScopesList());
};




export const redirectToScopesList = () => ({
  type: REDIRECT_TO_SCOPES_LIST
});

const getScopesSuccess = (response, action) => ({
  type: SCOPES_GET_SUCCESS,
  record: response,
  actionType: action
});


const scopesSuccessNotification = message => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: 'success'
});


export const hideScopesValidationError = feild_key => ({
  type: HIDE_SCOPES_FEILD_VALIDATION_ERROR,
  feild_key: feild_key
});

export const scopesListFetch = (user_id) => {

  var token = localStorage.getItem('token');
  return dispatch => {
    dispatch(scopesRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + 'scopes/getAll', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer ' + token
      },

    }).then(
      response => {
        dispatch(hideCommonLoader());
        dispatch(scopesListSuccess(response.data));
      },
      error => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

export const addScopes = data => {
  var token = localStorage.getItem('token');
  return dispatch => {
    dispatch(scopesRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + 'scopes/create', {
      method: 'POST',
      headers: {

        Accept: 'application/json',
        Authorization: 'Bearer ' + token
      },
      data: data
    }).then(
      response => {
        dispatch(hideCommonLoader());
        scopesAddUpadteSuccess(
          'Scopes Added Successfully',
          'create',
          dispatch
        );

      },
      error => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
        // dispatch(workspaceFailure("The name has already been taken"))
      }
    );
  };
};









export const updateScopes = (data) => {
  const id = data.id; // Make sure `id` exists on `data`
  const token = localStorage.getItem('token');

  return async (dispatch) => {
    dispatch(scopesRequest());
    dispatch(showCommonLoader());

    try {
      await axios(API_URL + 'scopes/update/' + id, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + token,
        },
        data: data, // send whole object (must match Laravel expectations)
      });

      scopesAddUpadteSuccess(
        'Scopes Updated Successfully',
        'update',
        dispatch
      );

    } catch (error) {
      handleErrorResponse(error, dispatch);
    } finally {
      dispatch(hideCommonLoader());
    }
  };
};





export const getScopesById = (id, action) => {
  var token = localStorage.getItem('token');
  return dispatch => {
    dispatch(scopesRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + 'scopes/getById/' + id, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer ' + token
      }
    }).then(
      response => {
        dispatch(hideCommonLoader());
        dispatch(getScopesSuccess(response.data, action));
      },
      error => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};


export const deleteScopes = (id, object_viewed_id) => {
  var token = localStorage.getItem('token');
  return dispatch => {
    dispatch(scopesRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + 'scopes/delete/' + id, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer ' + token
      },
      data: {
        object_viewed_id
      }
    }).then(
      response => {
        dispatch(hideCommonLoader());
        dispatch(
          scopesSuccessNotification('Scopes deleted successfully')
        );
      },
      error => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};




// handling error reponse
const handleErrorResponse = (error, dispatch) => {
  try {
    if (error.response.status === 422 && error.response.data.error) {

      dispatch(validationError(error.response.data.error));
    } else if (error.response.status === 401 && error.response.data.error) {
      dispatch(tokenError(error.response.data.error.toString()));
    } else {
      let err = '';
      if (error.response.data.error) {
        err = error.response.data.error.toString();
      } else {
        err = error.response.status + ` ` + error.response.statusText;
      }
      dispatch(scopesFailure(err));
    }
  } catch (e) {
    dispatch(scopesFailure('Unable to perform action.Something went wrong'));
  }
};





























